import { init } from 'vwo-fme-node-sdk';
import { store } from '@redux/store';
import { selectConfigurationVwoSdkKey, selectConfigurationVwoAccountId } from 'layout/redux/selectors';

// Singleton promise — VWO client is initialized only once per page load.
let clientPromise = null;

const getClient = () => {
  if (!clientPromise) {
    const state = store.getState();
    const sdkKey = selectConfigurationVwoSdkKey(state);
    const accountId = selectConfigurationVwoAccountId(state);

    if (!sdkKey || !accountId) {
      // returning a promise of null if we don't have keys right now
      // we may in the future though (as we get them from an async request)
      return Promise.resolve(null);
    }

    clientPromise = init({ accountId: String(accountId), sdkKey });
  }
  return clientPromise;
};

/**
 * Tracks a VWO FME event for the given user.
 * @param {string} eventName - The VWO event name configured in the FME dashboard.
 * @param {string} userId - The user identifier (e.g. Segment anonymous ID).
 * @param {Object} [properties] - Optional event properties.
 */
export const trackEvent = async (eventName, userId, properties) => {
  if (!userId) { return; }
  const client = await getClient();
  if (!client) { return; }
  client.trackEvent(eventName, { id: userId }, properties);
};

export { getClient as getVwoClient };
